import request from "../utils/request";

export async function getBranchTableMap() {
  return request.get("BranchTables");
}

export async function saveBranchTableMap(branchTableMapModel) {
  const payload = {
    branchId: null, // Assuming BranchId is not provided in the current implementation
    value: JSON.stringify(branchTableMapModel)
  };
  return request.post("BranchTables", payload);
}
export async function addTableArea(tableAreaDto) {
  return request.post("BranchTables/area", tableAreaDto);
}
export async function getBranchMap() {
  return request.get("BranchTables/area");
}

export async function addTable(tableDto) {
  console.log(tableDto);

  return request.post("BranchTables/table", tableDto);
}

export async function updateTable(tableDto) {
  console.log(tableDto);

  return request.put("BranchTables/table", tableDto);
}

export async function deleteTable(id) {
  return request.delete(`BranchTables/table/${id}`);
}

export async function deleteArea(id) {
  return request.delete(`BranchTables/area/${id}`);
}


export async function reorderTables(tableReOrderDtos) {
  console.log(tableReOrderDtos);
  return request.post("BranchTables/table/reorder", JSON.stringify(tableReOrderDtos), {
    headers: {
      'Content-Type': 'application/json'
    }
  });
}


